<template>

    <div class="new-list-group mb-12">
        <div class="new-list-group-item new-list-group-header no-decoration">
            <div class="row">
                <div class="col-3">
                    Datum
                </div>
                <div class="col-4">
                    Tillagd av
                </div>
                <div class="col-5" v-if="type === 'contact'">
                    Tilldelad till
                </div>
                <div class="col-5" v-else>
                </div>
                <div class="col-7">
                    Kommentar
                </div>
                <div class="col-2" v-if="type === 'contact'">
                    Avklarad
                </div>
            </div>
        </div>

        <div class="new-list-group-item" :key="'e'+entry.id" v-for="entry in entries">
            <div class="row">
                <div class="col-md-3">
                    {{ entry.date_at }}
                </div>
                <div class="col-md-4">
                    <span v-if="entry.admin">{{ entry.admin.name }}</span>
                    <span v-else>Systemet</span>
                </div>
                <div class="col-md-5" v-if="type === 'contact'">
                    {{ entry.assigned_admin.name }}
                </div>
                <div class="col-5" v-else>
                </div>
                <div class="col-md-7">
                    {{ entry.comment }}
                </div>
                <div class="col-md-1">
                    <img src="/images/check.png" style="width:22px;" v-if="entry.done_at">
                </div>
                <div class="col-md-4 d-flex justify-content-end">
                    <div class="btn btn-sm btn-info me-1" @click="edit(entry)" v-if="type === 'contact'">
                        Ändra
                    </div>
                    <div class="btn btn-sm btn-danger" @click="triggerDelete(entry.id)">
                        <img src="/images/admin/icon-trash.svg">
                    </div>
                </div>
            </div>
        </div>

        <div class="new-list-group-item new-list-group-item-add py-3">
            <div class="row d-flex align-items-start">
                <div class="col-3">
                    <datepicker-new
                        input-class="form-control form-control-sm"
                        placeholder="Välj"
                        :use-utc="false"
                        :language="former.datepicker.locale"
                        :monday-first="true"
                        :disabled-dates="former.datepicker.disabledDates"
                        :format="formerDateFormat"
                        v-model="newLogEntry.date_at"
                    />
                </div>
                <div class="col-4">
                    {{ user_name }}
                </div>
                <div class="col-5" v-if="type === 'contact'">
                    <select class="form-select" v-model="newLogEntry.assigned_admin_id">
                        <option :key="'a'+admin.id" v-for="admin in admins" :value="admin.id">{{ admin.name }}</option>
                    </select>

                    <div style="margin-top: 10px;" v-if="newLogEntry.assigned_admin_id === user_id">
                        Skicka epost <input type="checkbox" v-model="newLogEntry.send_email_to_self" />
                    </div>
                </div>
                <div class="col-5" v-else>
                </div>
                <div class="col-7">
                    <textarea class="form-control" style="height: 80px;" v-model="newLogEntry.comment"></textarea>
                </div>
                <div class="col-md-1">
                    <input type="checkbox" v-model="newLogEntry.is_done" v-if="type === 'contact' && newLogEntry.id" />
                </div>
                <div class="col-4 d-flex justify-content-end">
                    <button class="btn btn-primary btn-sm" :disabled="poster.submitted" @click="posterPost('log')" v-if="!newLogEntry.id">
                        <span class="spinner-border spinner-border-sm"></span>
                        Lägg till
                    </button>
                    <button class="btn btn-sm btn-info me-1" @click="resetNewLogEntry()" v-if="newLogEntry.id">
                        Avbryt
                    </button>
                    <button class="btn btn-sm btn-primary" :disabled="patcher.submitted" @click="patcherPatch()" v-if="newLogEntry.id">
                        <span class="spinner-border spinner-border-sm"></span>
                        Spara
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import poster from '../../../../shared/mixins/poster'
import patcher from '../../../../shared/mixins/patcher'
import deleter from '../../../../shared/mixins/deleter'

const emptyNewLogEntry = {
    id: null,
    mode: 'store',
    date_at: new Date(),
    comment: '',
    assigned_admin_id: user_id,
    send_email_to_self: false
}

export default {

    mixins: [
        poster,
        patcher,
        deleter
    ],

    props: {
        company: {
            required: true
        },
        type: {
            required: true // info || contact
        },
        entries: {
            required: true
        },
        admins: {
            required: true
        }
    },

    data () {
        return {
            user_name: user_name,
            user_id: user_id,
            newLogEntry: {},
            logLimit: 5
        }
    },

    created () {
        this.resetNewLogEntry()
    },

    computed: {
        posterUrl () {
            return '/companies/' + this.company.id + '/logEntries'
        },
        posterData () {
            return { type: this.type, ...this.newLogEntry }
        },
        patcherUrl () {
            return '/companies/' + this.company.id + '/logEntries/' + this.newLogEntry.id
        },
        patcherData () {
            return { type: this.type, ...this.newLogEntry }
        },
        deleterUrl () {
            return '/companies/' + this.company.id + '/logEntries'
        }
    },

    methods: {
        resetNewLogEntry () {
            this.newLogEntry = Object.assign({}, emptyNewLogEntry)
        },

        edit (entry) {
            this.newLogEntry = Object.assign({}, entry)
        },

        posterSuccess (data) {
            this.resetNewLogEntry()
            bus.$emit(
                'notify',
                'Sparat'
            )
            this.$emit('refresh')
        },

        patcherSuccess (data) {
            this.resetNewLogEntry()
            bus.$emit(
                'notify',
                'Sparat'
            )
            this.$emit('refresh')
        },

        triggerDelete (log_entry_id) {
            if (!confirm('Är du säker')) {
                return
            }
            this.deleterDelete(log_entry_id)
        },

        deleterSuccess (data) {
            bus.$emit(
                'notify',
                'Borttaget'
            )
            this.$emit('refresh')
        }
    }

}
</script>
